import { Extension } from "@tiptap/core";
import { CoreExtensionNames } from "../constants/extention";
import { DropHandlerPlugin } from "./drop-handler-plugin";

type TActiveDropbarExtensions = CoreExtensionNames.MENTION;

export interface UtilityExtensionStorage {
  activeDropbarExtensions: TActiveDropbarExtensions[];
  isTouchDevice: boolean;
  uploadInProgress?: boolean;
}

declare module "@tiptap/core" {
  interface Commands {
    utility: unknown;
  }
  interface Storage {
    [CoreExtensionNames.UTILITY]: UtilityExtensionStorage;
  }
}

interface UtilityExtensionProps {
  isTouchDevice: boolean;
  isEditable?: boolean;
  uploadImage?: (file: File) => Promise<string>;
}

export const UtilityExtension = (props: UtilityExtensionProps) => {
  const { isTouchDevice, uploadImage } = props;

  return Extension.create<Record<string, unknown>, UtilityExtensionStorage>({
    name: "utility",
    priority: 1000,

    addProseMirrorPlugins() {
      return [
        DropHandlerPlugin({
          editor: this.editor,
          uploadImage
        })
      ];
    },

    addStorage() {
      return {
        activeDropbarExtensions: [],
        isTouchDevice,
        uploadInProgress: false
      };
    }
  });
};
